<template>
    <div class="contentArea pt-0">
        <Banner />
        
    </div>
</template>

<script>
    import Banner from './elements/banner/Banner.vue'
 
    import mapGetters from "vuex";
    export default {
        components:{
            Banner
        },
        // async mounted(){
        //     await this.$store.dispatch("general/get_banner")
        // },
        // computed: {
        //     ...mapGetters({
        //         language: "general/language"
        //     })

        // }
    }
   
</script>

<style lang="scss" >

</style>